/**
 * Route for `per-campaign-fraud-toggle-threshold-sliders`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { PerCampaignFraudToggleThresholdSlidersPage } from "../features/per-campaign-fraud-toggle-threshold-sliders/PerCampaignFraudToggleThresholdSlidersPage";

export const perCampaignFraudToggleThresholdSlidersRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/per-campaign-fraud-toggle-threshold-sliders",
	component: PerCampaignFraudToggleThresholdSlidersPage,
});

export default perCampaignFraudToggleThresholdSlidersRoute;
